import Swiper, { Pagination, Navigation } from "swiper"

const QuizzSlider = {
	initSwiper: () => {
		return new Swiper(".swiper", {
			modules: [Pagination, Navigation],
			slidesPerView: 1,
			speed: 400,
			allowTouchMove: false,
			pagination: {
				el: ".swiper-pagination",
				type: "bullets",
				bulletClass: "swiper-pagination__bullet",
				bulletActiveClass: "swiper-pagination__bullet--current",
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: null,
			},
		})
	},

	setPaginationFraction: (fraction, swiper) => {
		if (!fraction) return
		fraction.textContent = `${swiper.realIndex + 1} / ${swiper.slides.length}`
	},

	/**
	 * Required for pagination custom CSS
	 * @param {HTMLElement} pagination
	 * @param {Object} swiper
	 * @returns
	 */
	setPaginationStyle: (pagination, swiper) => {
		if (!pagination || !swiper) return
		pagination.style.gridTemplateColumns = `repeat(${swiper.slides.length - 1}, 1fr) 16px`
	},

	/**
	 * Extends default Swiper pagination
	 * Add class to previous bullets
	 * @param {HTMLElement} pagination
	 * @param {Object} swiper
	 * @returns
	 */
	updatePaginationProgress: (pagination, swiper) => {
		if (!pagination || !swiper) return
		const cssModifier = "swiper-pagination__bullet--passed"
		let previousNav = pagination.children[swiper.previousIndex]
		if (!previousNav.classList.contains(cssModifier)) {
			previousNav.classList.add(cssModifier)
		}
	},

	getCurrentSlide: (swiper) => {
		if (!swiper) return
		return swiper.slides[swiper.realIndex]
	},
}

export default QuizzSlider
